// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Tv-z","tooltipWrapper":"Uv-z","icon":"Vv-z","tooltip":"Wv-z","content":"Xv-z"};